import { PayoutType } from 'types';
import { Payout } from 'store/api/payout';
import { formatPrice, joinStrings } from 'utils/helpers';

import { Card } from './card';
import { signedAmountTypes } from './config';
import { TotalInfoCardProps } from './types';

export const TotalInfoCard = ({
  type,
  title,
  isDeduction,
  selectedValues,
}: TotalInfoCardProps) => {
  const filteredValues = selectedValues.filter((value) => {
    if (value.type !== type) {
      return false;
    }

    if (signedAmountTypes.includes(type)) {
      const amount = Number(value.amount || 0);
      return isDeduction ? amount < 0 : amount > 0;
    }

    return true;
  });

  const { amount, otherEventAdjustments } = filteredValues.reduce(
    (acc, value) => ({
      amount: acc.amount + Number(value.amount || 0),
      otherEventAdjustments: value?.originalEventId
        ? [...acc.otherEventAdjustments, value]
        : acc.otherEventAdjustments,
    }),
    { amount: 0, otherEventAdjustments: [] as Payout[] }
  );

  const formattedAmount = formatPrice(Math.abs(amount));

  const descriptions =
    type === PayoutType.Misc
      ? joinStrings(
          filteredValues.map((value) => value?.notes),
          ', '
        )
      : undefined;

  return filteredValues.length > 0 ? (
    <Card
      type={type}
      title={title}
      isDeduction={isDeduction}
      description={descriptions}
      otherEventAdjustments={otherEventAdjustments}
      value={isDeduction ? `-${formattedAmount}` : formattedAmount}
    />
  ) : null;
};
